import axios from 'axios';
import c from '../helpers/constants';
import { EmailCompletePasswordReset, EmailDeleteAccount, EmailForgotPassword, EmailInvoiceQuery, EmailMessage, EmailNewPassword, EmailNotifyStock, EmailUpdateDetails } from '../types/Email';
import { getCustomerPostcode } from '../helpers/functions';

export function submitMessage(data: EmailMessage) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_SUBMIT_MESSAGE}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function sendQueryEmail(data: EmailInvoiceQuery){
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_INVOICE_QUERY}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function forgotPassword(data: EmailForgotPassword) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_FORGOT_PASSWORD}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function newPassword(data: EmailNewPassword, useToken?: boolean) {

  if(useToken) {
    data.password = getCustomerPostcode( ) ?? '';
  }

  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_NEW_PASSWORD}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function completePasswordReset(data: EmailCompletePasswordReset) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_COMPLETE_PASSWORD_RESET}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
  );
}



export function newPasswordRequest( customerId: string, email: string) {


  return (
    axios({
      url: `${c.API_ENDPOINTS.RESET_PASSWORD_REQUEST}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
          customerId: customerId,
          email: email,
      }),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function notifyStock(data: EmailNotifyStock) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_NOTIFY_STOCK}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function deleteAccount(data: EmailDeleteAccount) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_DELETE_ACCOUNT}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function updateDetails(data: EmailUpdateDetails) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_UPDATE_DETAILS}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}